import { BioCardDirectoryProps } from '@ahc-digital/component-library';
import { useI18n } from 'next-localization';
import { getDroplink } from 'src/shared/param-utils';
import { C55BiographyDirectoryProps } from './C55BiographyDirectory.types';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';

export function GetBiographyDirectoryModel(
  props?: C55BiographyDirectoryProps
): BioCardDirectoryProps {
  const { t } = useI18n() || {};
  const { fields, params } = props || {};
  const { renderText, renderRichText, renderImage, renderLink } = useConditionalRendering();

  const bios =
    fields?.Biographies?.map((bioItem) => {
      const { fields } = bioItem;

      return {
        additional: renderRichText(fields?.AdditionalInfo),
        email: renderText(fields?.Email),
        fax: renderText(fields?.Fax),
        locations: renderRichText(fields?.Locations),
        name: renderText(fields?.Name),
        displayName: renderText(fields?.DisplayName),
        phone: renderText(fields?.Phone),
        specialty: renderText(fields?.Specialty),
        title: renderText(fields?.Title),
        image: renderImage(fields?.Image),
        optionalLink: renderLink(fields?.DetailedBioLink),
      };
    }) || [];

  return {
    additionalInformationLabel: t('BioCard-AdditionalInformation'),
    headline: renderText(fields?.Title),
    headlineTag: getDroplink(params?.HeadlineTag, 'p'),
    bios: bios,
    emailLabel: t('BioCard-Email'),
    faxLabel: t('BioCard-Fax'),
    locationsLabel: t('BioCard-Locations'),
    phoneLabel: t('BioCard-Phone'),
    specialtyLabel: t('BioCard-Specialty'),
    titleLabel: t('BioCard-Title'),
  };
}
